<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </h6>
        </div>
      </div>
    </base-header>

    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <associate-order-list :orders="orders" :projection="projection" @addOrder="saveOrder" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <projection-data :projection="projection" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProjectionData from '@/views/Projection/Show/ProjectionData';
import AssociateOrderList from './List/AssociateOrderList';

export default {
  components: {
    RouteBreadCrumb,
    ProjectionData,
    AssociateOrderList,
  },

  data() {
    return {
      projectionId: null,
      isDataLoaded: false,
      projection: null,
      orders: [],
    };
  },

  mounted() {
    this.projectionId = +this.$route.params.id;
    this.fetchProjection();
  },

  methods: {
    fetchProjection() {
      const params = {
        include: ['variety.crop', 'campaign.crops', 'producer.distributor'],
      };
      this.$services
        .resource('projections')
        .show(this.projectionId, params)
        .then((res) => res.data.data)
        .then((projection) => {
          this.projection = projection;
          this.canAssignOrder = !this.isProjectionConfirmed;
          this.fetchOrdersData();
        });
    },

    fetchOrdersData() {
      const params = {
        'filter[campaign]': this.projection.campaignId,
        'filter[producer]': this.projection.producerId,
        'filter[without_projection]': true,
        'filter[state]': 3,
        'filter[withTrashed]': true,
        include: ['producer.distributor.seller', 'campaign', 'user', 'state', 'projection', 'items.article'],
      };
      this.$services
        .resource('orders')
        .get(params)
        .then((res) => {
          return (this.orders = res.data.data.orders);
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },

    saveOrder(order) {
      this.$services
        .resource('orders')
        .addProjection(order)
        .then(() => {
          this.fetchOrdersData();
          swal({
            title: 'Listo!',
            text: 'El pedido fue asignada a su proyeccion.',
            type: 'success',
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: 'Ir al listado',
            cancelButtonText: 'Ver proyección',
            confirmButtonClass: 'btn btn-secondary',
            cancelButtonClass: 'btn btn-success',
          }).then((choice) => {
            if (choice.value) {
              this.$router.push({ name: 'ProjectionsList' });
            } else {
              this.$router.push({ name: 'ProjectionShow', params: { id: this.projection.id } });
            }
          });
        })
        .catch((errors) => {
          // this.serverErrors = errors
        });
    },
  },
};
</script>
